import { DYNAMIC_ICONIC_SPRITE_URL } from '../../../constants';

type GetSpriteUrlParams = {
  spriteId: string;
};

/**
 * Gets the sprite URL for a given sprite ID.
 *
 * @param params.spriteId - The sprite identifier from the wallet book.
 * @returns The full URL to the sprite icon
 */
export const getSpriteUrl = ({ spriteId }: GetSpriteUrlParams): string =>
  `${DYNAMIC_ICONIC_SPRITE_URL}#${spriteId}`;
